import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import PartnershipModal from './PartnershipModal';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPartnershipModal, setShowPartnershipModal] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/80 border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_trusted-journeys-co/artifacts/wlco41wl_Blue%20365.png"
              alt="No Limit 365 Transportation"
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-[#0B0F14] hover:text-[#0077BE] font-semibold transition-colors"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-[#0B0F14] hover:text-[#0077BE] font-semibold transition-colors"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('training')}
              className="text-[#0B0F14] hover:text-[#0077BE] font-semibold transition-colors"
            >
              Training
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-[#0B0F14] hover:text-[#0077BE] font-semibold transition-colors"
            >
              FAQ
            </button>
            <Button 
              onClick={() => {
                setShowPartnershipModal(true);
                setIsMenuOpen(false);
              }}
              className="bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white hover:shadow-lg rounded-xl px-6 transition-all duration-300 hover:scale-105"
            >
              Start Partnership
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-[#0B0F14]" />
            ) : (
              <Menu className="w-6 h-6 text-[#0B0F14]" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3 border-t border-gray-200 pt-4">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-2 text-[#0B0F14] hover:bg-[#F7F9FB] rounded-lg font-semibold"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-2 text-[#0B0F14] hover:bg-[#F7F9FB] rounded-lg font-semibold"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('training')}
              className="block w-full text-left px-4 py-2 text-[#0B0F14] hover:bg-[#F7F9FB] rounded-lg font-semibold"
            >
              Training
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-4 py-2 text-[#0B0F14] hover:bg-[#F7F9FB] rounded-lg font-semibold"
            >
              FAQ
            </button>
            <Button 
              onClick={() => {
                setShowPartnershipModal(true);
                setIsMenuOpen(false);
              }}
              className="w-full bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white rounded-xl"
            >
              Start Partnership
            </Button>
          </nav>
        )}
      </div>
      
      {/* Partnership Modal */}
      <PartnershipModal 
        open={showPartnershipModal} 
        onOpenChange={setShowPartnershipModal}
      />
    </header>
  );
};

export default Header;
